"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'db.operation.create': '创建',
    'db.operation.update': '更新',
    'db.operation.delete': '删除',
    'db.operation.upsert': 'Upsert',
    'db.operation.createMany': '批量创建',
    'db.operation.updateMany': '批量更新',
    'db.operation.deleteMany': '批量删除',
    'db.operation.findFirst': '查找第一个',
    'db.operation.findMany': '查找多个',
    'db.operation.findUnique': '查找唯一',
    'db.operation.count': '计数',
    'db.operation.aggregate': '聚合',
    'db.operation.groupBy': '分组',
};
